import {
  useRegisterProfileActivityMutation,
} from 'graphql/mutation/register.profile.activity.mutation'
import posthog from 'posthog-js'
import { useAppDispatch, useAppSelector } from 'store'
import { addTriggers } from 'store/trigger'
import { ID } from 'utils/id'

let count = 0

type PayloadType = {
  [key: string]: string| number | boolean
}

export const useRegisterActivity = (): ((
  activity: string,
  company?: ID,
  payload?: PayloadType
) => Promise<void>) => {
  const dispatch = useAppDispatch()
  const authenticated = useAppSelector((state) => (
    state.auth.authenticated
  ))

  const fallbackCompany = useAppSelector((state) => state.company.id)

  const [registerActivity] = useRegisterProfileActivityMutation({
    onCompleted: (data) => {
      if (data.status === null || data.status.triggers === null) {
        return
      }

      const newTriggers = data.status.triggers.map((trigger) => {
        return { id: String(count++), ...trigger }
      })

      dispatch(addTriggers(newTriggers))
    },
  })

  return async (activity: string, company?: ID, payload?: PayloadType) => {
    const filteredPayload = {}

    if (payload) {
      Object
        .keys(payload)
        .filter(key => payload[key] !== null && payload[key] !== undefined)
        .forEach(key => filteredPayload[key] = payload[key])
    }

    posthog.capture(activity, {
      ...filteredPayload,
      company: company === undefined ? fallbackCompany : company,
    })

    if (!authenticated) {
      return
    }

    const variables = {
      activity,
      company: null,
      payload: payload ? JSON.stringify(filteredPayload) : undefined,
    }

    if (company !== undefined) {
      variables.company = company
    } else if (fallbackCompany) {
      variables.company = fallbackCompany
    }

    if (variables.company === 'undefined') {
      variables.company = null
    }

    await registerActivity({
      context: {
        batch: false,
      },
      variables,
    })
  }
}
